const actionBaseName = '[CorePublic]';

export class CorePublicAction {
  static readonly type = actionBaseName + 'AddItem';
  constructor(public payload: string) { }
}
